import { render, staticRenderFns } from "./UserDetailsDialog.vue?vue&type=template&id=58057865&scoped=true"
import script from "./UserDetailsDialog.vue?vue&type=script&lang=js"
export * from "./UserDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./UserDetailsDialog.vue?vue&type=style&index=0&id=58057865&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58057865",
  null
  
)

export default component.exports